<div class='color' [ngStyle]="{'background': color}" [ngClass]="{'light': !isDark, 'dark': isDark, 'shadow': isShadow}" >{{color}}</div>
